export default __webpack_public_path__ + "static/media/15919 - Luke.b3ed277d.jpeg";